import { Icon } from '@progress/kendo-react-common';
import React, { Fragment } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';

const NavCustomizer = ({ callbackNav, selected }) => {
    return (
        <Fragment>
            <Nav className="flex-column nac-pills" id="c-pills-tab" role="tablist" aria-orientation="vertical">
                <NavItem>
                    <NavLink className={selected === 'check-layout' ? 'active' : ''} onClick={() => callbackNav('check-layout', true)}>
                        <div className="settings">
                        <Icon  name="layout" />
                            </div>
                        <p>Check Layout</p>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={selected === 'sidebar-type' ? 'active' : ''} onClick={() => callbackNav('sidebar-type', true)}>
                        <div className="settings">
                        <Icon  name="gears" />
                        </div>
                        <p>Sidebar Type</p>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={selected === 'color-picker' ? 'active' : ''} onClick={() => callbackNav('color-picker', true)}>
                        <div className="settings color-settings">
                        <Icon  name="palette" />
                            </div>
                        <p>Color Picker</p>
                    </NavLink>
                </NavItem>
            </Nav>
        </Fragment>
    );
};

export default NavCustomizer;